module.exports = __webpack_public_path__ + "img/Logo-text.7f52ff9f.svg";